import { httpClient } from "@/services";

export default {
	state: {
		settingsContactsTypes: [],
		contactsTypesContactsTypes: [],
		filtersContactsTypes: {},
		editContactsTypes: {},
		editContactsTypesParent: {},
	},
	mutations: {
		updateContactsTypes(state, { settings, items, filters }) {
			state.settingsContactsTypes = settings;
			state.contactsTypesContactsTypes = items;
			state.filtersContactsTypes = filters;
		},
		updateEditContactsTypes(state, { department, parent }) {
			state.editContactsTypes = department;
			state.editContactsTypesParent = parent;
		},
	},
	actions: {

		async deleteAccountContactsTypes({ dispatch }, id) {
			try {
				const { data } = await httpClient.delete(`/info/contacts-types/${ id }`);
				if (data && data.status) {
					dispatch('getAccountContactsTypesList', true);
				}
			} catch (e) {
				console.error(e);
			}
		},

		async getAccountContactsTypesList({ commit, dispatch }) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get("/info/contacts-types");
				if (data) {
					commit('updateContactsTypes', data);
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},

		async onAccountContactsTypesEdit({ commit, dispatch }, args ) {
			try {
				const { id, sendInfo } = args;
				const { data } = await httpClient.put(`/info/contacts-types/${ id }`, sendInfo);
				if ( data ) {
					commit('updateAccountSettings', data);
					return data;
				}
				dispatch('setAlert', { type: "error", message: "Save data error" });
			} catch (e) {
				console.error(e);
			}
		},

		async onAccountContactsTypesSave({ commit, dispatch }, args) {
			// dispatch("actionPreloader", true);
			try {
				const { sendInfo } = args;
				const { data } = await httpClient.post("/info/contacts-types", sendInfo);
				if ( data ) {
					commit('updateAccountSettings', data);
					// dispatch("actionPreloader", false);
					return data;
				}
				dispatch('setAlert', { type: "error", message: "Save data error" });

			} catch (e) {
				console.error(e);
			}
		},

		async getAccountContactsTypesEdit({ commit, dispatch }, id) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get(`/info/contacts-types/${ id }/edit`);
				if (data && data.status) {
					commit('updateEditContactsTypes', data);
					dispatch("actionPreloader", false);
					return data;
				}
				dispatch('setAlert', { type: "error", message: "Save data error" });

			} catch (e) {
				console.error(e);
			}
		},
		// onDefaultList({ commit }) {
		// 	commit('updateDefaultList');
		// }
	},
	getters: {
		editContactsTypes: s => s.editContactsTypes,
		editContactsTypesParent: s => s.editContactsTypesParent,
		settingsContactsTypes: s => s.settingsContactsTypes,
		contactsTypesContactsTypes: s => s.contactsTypesContactsTypes,
		filtersContactsTypes: s => s.filtersContactsTypes,
	},
};
